export default __webpack_public_path__ + "static/media/Galileo logo.1aad2d72.png";